import { RouteRecordRaw } from 'vue-router'
import marketingModules from './marketing-module'

const unifiedPage = () => import('@/modules/Mfa/UnifiedPage.vue')

export const billingRoutes: RouteRecordRaw[] = [
{
    path: 'account-&-billing',
    name: 'account-&-billing',
    meta: {
      module: {...marketingModules.marketing.defaultLayoutPage, mountProps: {
        base: "/accounts",
      }},
      moduleName: 'Account_billing',
    },
    component: unifiedPage,
    children: [
      {
        path: "",
        name: "Account_settings_overview",
        component: ()=>import('@/lib/layouts/DefaultLayout.vue'),
       },
      
      {
        path: "company-information",
        name: "Account_settings_account",
        component: ()=>import('@/lib/layouts/DefaultLayout.vue'),
      },
      {
        path: "usage",
        name: "Account_usage",
        component: ()=>import('@/lib/layouts/DefaultLayout.vue'),
      },
      {
        path: "subscriptions",
        name: "Account_subscription",
        component: ()=>import('@/lib/layouts/DefaultLayout.vue'),
      }
    ]
  },
]